const handleOnChange = (event, dynamicHeight, containerRef, onChange) => {
    if (dynamicHeight) {
        const wrapper = containerRef.current;
        const textarea = event.target;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
        wrapper.style.height = `${textarea.scrollHeight + 30}px`;
    }
    onChange(event);
};
export default handleOnChange;
